import styled from "styled-components";

export const Container = styled.span`
	display: inline-block;
	width: fit-content;
	padding: 0 0.5rem;
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	border-radius: 10px;
	color: ${({ theme }) => theme.pantone2726C};
	font-size: 0.7rem;
	font-weight: 400;
	line-height: 1.1rem;
	white-space: nowrap;
`;
